import React, { useState, useEffect, useRef } from "react"
import { twJoin } from "tailwind-merge"
import { Button } from "@/landing-page/components/button"
import { FEAT_OPTIONS } from "@/constants/options"
import { trackEvent } from "@/helpers/ga"

export function Manifestations() {
  const [selectedStyle, setSelectedStyle] = useState<any>(FEAT_OPTIONS[0])
  const [loaded, setLoaded] = useState<boolean>(true)
  const firstRender = useRef(true)

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
    } else {
      setLoaded(false)
    }
  }, [selectedStyle])

  return (
    <section
      className="bg-gradient-to-r from-green-dark to-green-light lg:py-16 lg:pb-12 py-10 pb-6 dark:bg-none dark:bg-black dark:border-t"
      id="manifestacoes"
    >
      <div className="container lg:pr-8 pr-0 flex flex-col items-center">
        <h2 className="font-serif text-sand text-center lg:text-6xl text-3xl lg:mb-7 mb-6 lg:mr-0 mr-8">
          ARTISTAS SELECIONADOS
        </h2>

        {FEAT_OPTIONS && (
          <ul className="lg:grid lg:grid-cols-5 flex lg:gap-6 gap-4 mb-8 lg:overflow-visible overflow-x-scroll w-full">
            {FEAT_OPTIONS.map((item, index) => (
              <li key={index} className="lg:last:mr-0 last:mr-8">
                <button
                  className={twJoin(
                    selectedStyle.label == item.label
                      ? "bg-red dark:hover:bg-red dark:text-white"
                      : "bg-blue dark:bg-white dark:text-black dark:hover:bg-red dark:hover:text-white",
                    "lg:w-full lg:min-w-max min-w-20 w-max text-base text-sand rounded-full py-3 px-2 font-bold hover:bg-red transition-all duration-300 ease-in-out cursor-pointer uppercase",
                  )}
                  type="button"
                  title={item.label}
                  onClick={() => {
                    trackEvent("interaction", item.track)
                    setSelectedStyle(item)
                  }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        )}

        <div
          className={twJoin(
            loaded ? "opacity-100" : "opacity-0",
            "lg:flex bg-white rounded-3xl p-4 lg:w-full lg:mr-0 mr-4 mb-8",
          )}
        >
          <div className="lg:p-6 py-6 lg:w-3/4 w-full">
            <h3 className="font-serif text-green-dark lg:text-6xl text-3xl mb-4 lg:text-start text-center dark:text-black uppercase max-w-full lg:leading-[120%]">
              {selectedStyle.title}
            </h3>
            <p
              className="text-green-dark text-lg dark:text-black"
              dangerouslySetInnerHTML={{ __html: selectedStyle.text }}
            />
          </div>

          <img
            className="block lg:w-1/4 w-full h-auto lg:max-h-96 lg:mr-0 mr-8 rounded-3xl overflow-hidden object-cover"
            loading="eager"
            src={selectedStyle.artistPicture}
            alt={selectedStyle.title}
            width={300}
            height={360}
            onLoad={() => setLoaded(true)}
          />
        </div>
      </div>
    </section>
  )
}
